import notifyMe from "../../../../services/backInStock/notifyMe";
import { clearSizeSelectError } from "../../../modules/savedItems/actions/notifyMe/clearSizeSelectError";
import { showSuccessBanner } from "../../../modules/savedItems/actions/notifyMe/showSuccessBanner";
import {
  SUCCESS_BANNER_OPT_IN_ALERT,
  SUCCESS_BANNER_PRIORITY_OPT_IN_ALERT
} from "../../savedItems/constants";

export const enableAlert =
  ({ variantId, isPriority }) =>
  dispatch => {
    dispatch(clearSizeSelectError());
    dispatch(
      showSuccessBanner({
        confirmationType: isPriority
          ? SUCCESS_BANNER_PRIORITY_OPT_IN_ALERT
          : SUCCESS_BANNER_OPT_IN_ALERT
      })
    );
    notifyMe({ variantId });
  };
